export function getStoreQr() {
    return {
        QrCode: 'demo-qr-code',
        company: 'demo company'
    }
}

export function getStoresWithinTheGroup() {
    return {
        "success": "true",
        "report": {
            "_id": "6720a733d821ddc2cc38aca4",
            "groupid": "6720a49bed59cc0095f81d13",
            "__v": 0,
            "createdAt": "2024-10-29T09:13:23.822Z",
            "store": [
                {
                    "storeName": "7-Star Educational Academy Corporation - Inhouse",
                    "adminId": "64f14ee8d8eb7b002d5b80c4"
                },
                {
                    "storeName": "7-Star Manpower Services of the Philippines Corp - Inhouse",
                    "adminId": "650280a757ac54002d49a33f"
                },
                {
                    "storeName": "Seven-Star Jasem Services Corporation - Inhouse",
                    "adminId": "650285db4106d8002d5dc10a"
                },
                {
                    "storeName": "Sparkle Star International - Inhouse",
                    "adminId": "64f15182dbd477002ddc95bf"
                },
                {
                    "storeName": "Star Capsicum Foods Corporation - Inhouse",
                    "adminId": "68d0bf32cf428a0068166162"
                },
                {
                    "storeName": "Star Cheese Foods Corporation - Inhouse",
                    "adminId": "689965aab6223c00748fc7b5"
                },
                {
                    "storeName": "Star Concorde Group of Companies",
                    "adminId": null
                },
                {
                    "storeName": "Star Food Group - Inhouse",
                    "adminId": "64f14e1bd8eb7b002d5b7f48"
                },
                {
                    "storeName": "Star Siam_Khiang Philippines-Inhouse",
                    "adminId": "674eb2992483110084ae3c59"
                },
                {
                    "storeName": "Star Terran Development Corporation Inhouse",
                    "adminId": "65dd3452562b48002e7c1bda"
                },
                {
                    "storeName": "Star Terran Development Corporation-Syzygy - Inhouse",
                    "adminId": "65deaaad821348002e42d8f1"
                },
                {
                    "storeName": "Starjobs Executive Search Corp - Inhouse",
                    "adminId": "64f15010b0fe26002d662fcf"
                },
                {
                    "storeName": "Syzygy Staffing Resources Agency Corporation - Inhouse",
                    "adminId": "64eef9f0e283e4002d489d8d"
                }
            ],
            "updatedAt": "2025-10-29T07:05:47.820Z"
        }
    }
}

export function getUsersWithinTheStore() {
    return [
        {
            "_id": "66a985cd1eba0f002e7c4cde",
            "googleId": null,
            "displayName": "Sparkle Demo",
            "firstName": "Sparkle",
            "lastName": "Demo",
            "image": "https://prod-timein.s3.ap-southeast-1.amazonaws.com/1774337259833.gif",
            "company": "SparkleTime KeepingDemo",
            "position": null,
            "email": "cosimshiena@gmail.com",
            "phone": "+639567444355",
            "verificationCode": null,
            "timeAdjustmentVerification": null,
            "isTimeAdjustmentVerified": false,
            "hashed_password": "6e5facccb35eb30cc2f382495cc364e9e5c91e0b",
            "resetToken": "526258",
            "role": 0,
            "isVerified": true,
            "isArchived": false,
            "isOnBoarded": true,
            "parentCompany": null,
            "location": null,
            "createdAt": "2024-07-31T00:31:08.881Z",
            "salt": "dfd9ff30-9b66-11ef-beb0-27603cfe7807",
            "updatedAt": "2026-04-21T07:23:03.106Z",
            "__v": 27,
            "alternativeBreaklistEmail": "",
            "changeMpinOtp": "",
            "mobileChangeOtp": "",
            "mpin": "",
            "newEmailOtp": "",
            "oldEmailOtp": "",
            "timeInQROTP": "",
            "uiVersion": "old",
            "useAlternativeBreaklistEmail": false,
            "readBroadcasts": [
                "6940d90a18da0a0069433d8f",
                "6940ea18a665b900573475d2",
                "6940eeab19a26100576a373d",
                "6940f58b18da0a006946574c",
                "6940f98718da0a0069470c2b",
                "6943b2e59d53bb00683a2c59",
                "6943b54d1132d613d49e7e54",
                "6943c2123d3929005716da4c",
                "6948dcee67add500576c31b6",
                "6948f79aee34760069c02c75",
                "6948f730316589005729b39a",
                "6948f7d55c133a005706c296",
                "6948f89baf21bd0057fb21eb",
                "6948f8d1316589005729b714",
                "69771c10701fdd0057e5e262",
                "697ad63cbdc8b50069d7a38e",
                "697ada43701fdd0057ec191c",
                "697adaeaccc60900570b14c6",
                "6983f026dbf3190057f14092",
                "69b3bce1c3a4410057ed2c1e",
                "69b3bdbe55a5a900572285d8",
                "69b3be0f5841480057a6c533",
                "69b3c99063a699006e9d5c15",
                "69b3d2d755a5a9005722c736",
                "69b3d2b324077f00575c4b3c",
                "69b3d28463a699006e9d7a42",
                "69b8e1960cf9750057bf0d0f"
            ],
            "scheduleCostOtp": "",
            "birthday": "2026-03-17T00:00:00.000Z",
            "pagIbigNumber": "5656-5656-5656",
            "philHealthNumber": "45-454545454-5",
            "sssNumber": "4545454545",
            "tinNumber": "121212121212",
            "emergencyContactNumber": "0909-090-9090",
            "dateHired": "2026-03-18T00:00:00.000Z",
            "currentAddress": "test brgy, test city",
            "emergencyContactPerson": "test",
            "emergencyContactRelationship": "test",
            "archiveRemarks": "",
            "lastRecordDate": "2026-04-15T00:00:00.000Z"
        },
    ]
}


export function getArchivedUsersOfTheStore() {
    return [
        {
            "_id": "61441920a6566a001623b90d",
            "googleId": null,
            "displayName": "Abigail  Domacena",
            "firstName": "Abigail ",
            "lastName": "Domacena",
            "image": null,
            "company": "Sparkle Star International - Inhouse",
            "position": "Project Head",
            "email": "domacenaabigail@gmail.com",
            "phone": "+639913833281",
            "verificationCode": null,
            "hashed_password": "89377fad0d78840cb2ebbc7b30617b397185b27f",
            "resetToken": "716150",
            "role": 1,
            "isVerified": true,
            "isOnBoarded": true,
            "createdAt": "2021-09-17T04:27:12.087Z",
            "updatedAt": "2026-04-25T09:06:16.730Z",
            "__v": 0,
            "salt": "a0a13190-176f-11ec-a216-6f82bf78f341",
            "location": "",
            "isArchived": true
        },
        {
            "_id": "620dc1cd33734e0037088669",
            "googleId": null,
            "displayName": "Adrian Permejo",
            "firstName": "Adrian",
            "lastName": "Permejo",
            "image": null,
            "company": "Sparkle Star International - Inhouse",
            "position": null,
            "email": "adrianpermejo64@gmail.com",
            "phone": "+639395151871",
            "verificationCode": null,
            "hashed_password": "f6604340b76ce8e42d84ad33e6ec2a87e9fa6074",
            "resetToken": null,
            "role": 1,
            "isVerified": true,
            "isArchived": true,
            "isOnBoarded": true,
            "parentCompany": null,
            "createdAt": "2022-02-17T03:32:29.013Z",
            "salt": "3bc71720-8fa2-11ec-a09f-63900a701e97",
            "updatedAt": "2024-06-05T06:02:53.957Z",
            "__v": 0,
            "isTimeAdjustmentVerified": false
        },
    ]
}

//stores/time-in-qr/get
export function getQrCodeOfTheStore() {
    return {"success":true,"QRCode":"aymdx47tcchdvj2fk99zz"}
}

//store/branch/61442a17a6566a001623bf20
export function getBranchInfo(){
    return []
}